export default function LiveRecordingWaveform({ bars = [] }) {
  return (
    <div
      className="flex h-9 min-w-0 flex-1 items-center justify-end overflow-hidden px-1"
      aria-hidden
    >
      {bars.map((level, i) => (
        <span
          key={i}
          className="mr-[1.5px] inline-block w-[3px] shrink-0 rounded-full bg-[#E52732]"
          style={{ height: `${16 + level * 84}%`, opacity: 0.45 + level * 0.55 }}
        />
      ))}
    </div>
  );
}
